
  <div class="modal-header bg-primary">
    <h4 class="modal-title">Frequência do aluno: {{ classe }} </h4>
    <button type="button" class="close" (click)="onClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-striped small align-items-center">
      <thead class="thead-light p-1">
        <tr>
          <th scope="col" class="p-1">Data Aula</th>
          <th scope="col" class="p-1">Dia Semana</th>
          <th scope="col" class="p-1">P01</th>
          <th scope="col" class="p-1">P02</th>
        </tr>
      </thead>
      <tbody>        
        <tr *ngFor="let l of attendance">                        
          <td class="p-1">{{ l.dataAula }}</td>
          <td class="p-1">{{ l.diaSemana }}</td>
          <td class="p-1">{{ l.presenca01 }}</td>
          <td class="p-1">{{ l.presenca02 }}</td>
        </tr>
      </tbody>
    </table>
  </div><!-- /.modal-body -->
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Fechar</button>
  </div><!-- /.modal-faoter -->
